import { Box, Stack, Typography } from '@mui/material';
import { Link } from 'components/common/Link';

import { colors } from 'styles/theme/colors';
import { ProductTypes } from 'types/ProductTypes';
import { useOrganisationPersonalWebshop } from 'hooks/useOrganisationPersonalWebshop';
import { useServerTranslation } from 'hooks/useServerTranslation';
import { Product, ProductImage } from '../../../generated/graphql';
import ProductPrice from '../../Product/components/ProductPrice';
import SafeImage from '../../SafeImage';
import { useNavigation } from '../../../hooks/useNavigation';

type ProductPreviewProps = {
    product: Product;
    index?: number;
    image?: ProductImage;
};

export function ProductPreview(props: ProductPreviewProps) {
    const { product, index, image } = props;
    const { name } = product;
    const { t } = useServerTranslation();

    const { shop } = useNavigation();

    return (
        <Link href={shop.product(product.slug || '')} key={index}>
            <Box display="flex">
                <Box>
                    <SafeImage
                        alt="product image"
                        src={image?.url}
                        width={60}
                        height={60}
                    />
                </Box>
                <Stack marginLeft={1} justifyContent="space-evenly">
                    <Typography>{name}</Typography>
                    {product.type === ProductTypes.WRAPPER
                        ? <Typography color={colors.secondary6}>{t('product.view-wrapper')}</Typography>
                        : <ProductPrice product={product} size={1} />}
                </Stack>
            </Box>
        </Link>
    );
}
